@use "../../variables" as *;
@use "../../mixins" as *;

.archive {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.375rem;

    @include desktop {
        gap: 2.25rem;
    }

    .headline {
        font-size: 1.25rem;

        @include desktop {
            font-size: 2rem;
        }
    }

    .header {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-weight: 500;
        color: #727272;

        @include desktop {
            font-size: 1.5rem;
            gap: 2.5rem;
        }

        .back {
            display: flex;
            align-items: center;

            @include desktop {
                span {
                    width: 1.313rem;
                    height: 1.313rem;

                    svg {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }

    .input {
        border: 1px solid #727272;
        padding: 0.875rem 1rem;
        border-radius: 0.625rem;
        display: flex;
        flex-direction: column;
        gap: 0.625rem;
        font-size: 0.875rem;
        box-shadow: 1px 1px 1px #00000030;
        color: #727272;
        cursor: text;

        @include desktop {
            font-size: 1.25rem;
            padding: 1rem 1.75rem;
            gap: 1.125rem;
        }

        &.active {
            padding: 0.75rem 1.75rem;
        }

        .label {
            display: flex;
            align-items: center;
            gap: 0.625rem;

            @include desktop {
                .icon {
                    display: flex;
                    align-items: center;

                    span {
                        width: 1.25rem;
                        height: 1.25rem;

                        svg {
                            width: 1.25rem;
                            height: 1.25rem;
                        }
                    }
                }
            }
        }

        .field {
            display: flex;
            align-items: center;
            gap: 1rem;

            .remove {
                cursor: pointer;
            }

            input {
                width: 100%;
                border: none;
                font: inherit;
                color: inherit;
                font-weight: 600;

                &:focus {
                    outline: none;
                }
            }
        }
    }

    .error {
        display: flex;
        align-items: center;
        gap: 1.125rem;
        flex-direction: column;
        margin-top: 4.25rem;
        text-align: center;

        svg {
            width: 1.5rem;
            height: 1.5rem;
            fill: #727272;
        }

        @include desktop {
            margin-top: 7.5rem;
            font-size: 1.25rem;

            span {
                max-width: 26rem;
                line-height: 1.625rem;
            }
        }

        .title {
            font-weight: 600;

            @include desktop {
                font-size: 1.5rem;
            }
        }
    }

    .details {
        border-radius: 1rem;
        border: 1px solid #CFCFCF;

        @include desktop {
            font-size: 1.25rem;
        }

        .row {
            display: flex;
            flex-direction: column;
            gap: 0.625rem;
            padding: 1.375rem;

            &:first-of-type {
                border-bottom: 1px solid #727272;
                border-radius: 1rem 1rem 0 0;

                @include desktop {
                    border-bottom-width: 2px;
                }
            }

            &:last-of-type {
                border-radius: 0 0 1rem 1rem;
            }

            &:nth-child(odd) {
                background-color: #F9F8F8;
            }

            .value {
                font-weight: 500;
            }
        }
    }
}
